import { createContext } from 'react';
import { TTypeOfReport, TTypeOfSchedule } from 'types';

export type TTypeOfModalWindow = null | 'deletionError';
interface IEmails {
	id: string;
	email: string;
}
export interface IReportsWithCustomProps {
	restaurantId: string;
	id: string;
	IDReportType: null | TTypeOfReport;
	IDsScheduleTypes: TTypeOfSchedule[];
	emails: IEmails[];
	copyEmails: IEmails[];
	sendingReportAfterShiftClosing: boolean;
}
export const CREATE_REPORT = 'createReport';
export const NEW_EMAIL_PREFIX = 'newEmail';
export const INCOMING_EMAIL_PREFIX = 'incomingEmail';
export const NEW_COPY_EMAIL_PREFIX = 'newCopyEmail';
export const INCOMING_COPY_EMAIL_PREFIX = 'incomingCopyEmail';

export interface IReportsContainerState {
	reports: IReportsWithCustomProps[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const reportsContainerInitialState: IReportsContainerState = {
	reports: [],
	typeOfModalWindow: null,
};

export interface IReportsContainerContext extends IReportsContainerState {
	addNewReport(): void;
	deleteReport(reportID: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const ReportsContainerContext = createContext<IReportsContainerContext>({
	addNewReport: () => undefined,
	deleteReport: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...reportsContainerInitialState,
});
